<app-loading *ngIf="contentReady"></app-loading>
<div class="wrap ">
  <div class="panel">

    <!-- الرصيد -->
    <div class="balance-card">

      <div class="label"> <img class="profile-icon" src="/assets/e-commerce/icons/53.webp">{{ "wallet balance" |
        transloco }} </div>
      <div class="amount"><span dir="ltr">{{balance}}</span> <span>{{ "egpe" |
          transloco }}</span></div>
    </div>
    <div class="cart-summary">
      <div class="section-title">{{ "Latest transactions" |
        transloco }}</div>
      @if(transactions === null){
      <br>
      <div style="text-align: center;">
        <img src="/assets/e-commerce/icons/74.webp" alt="product" class="product-img">
        <p class="no-data-text">
          {{ "No transactions" | transloco }}
        </p>
      </div>
      }
      @else{
      <ul class="txn-list" *ngFor="let transaction of transactions; let i = index">
        <li class="txn" [class.credit]="transaction.type === 'credit'" [class.debit]="transaction.type === 'debit'">
          <div class="amt">
            @if(transaction.type === 'debit'){
            -
            }
            @else{
            +
            }


            <span dir="ltr">{{transaction.amount}}</span> {{ "egpe" |
            transloco }}
          </div>
          <div class="side">
            @if(transaction.order_id){
            <div class="title">{{'order number' | transloco}} #{{transaction.order_id}} </div>
            }
            @else{
            <div class="title">{{transaction.note}} </div>
            }
            <div class="date">{{formatDate(transaction.created_at)}}</div>
          </div>
        </li>


      </ul>

      }
    </div>
  </div>
</div>